export function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
export function param(obj) {
  const params = []

  Object.keys(obj).forEach((key) => {
    let value = obj[key]
    // 如果值为undefined我们将其置空
    if (typeof value === 'undefined') {
      value = ''
    }
    // 对于需要编码的文本（比如说中文）我们要进行编码
    params.push([key, encodeURIComponent(value)].join('='))
  })

  return params.join('&')
}
export function getBaseUrl() {
  if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }
  return window.location.origin
}

export function getRouterTitle(to) {
  const {
    query: { type },
    meta: { baseTitle }
  }= to
  let title = type === '1' ? '查看' : '编辑'
  return baseTitle + title
}

export function goToPassport(timeout = 5000) {
  let href;
  if (/dev/.test(location.hostname)) {
    href =
      "http://passport.test.yunshanmeicai.com/?app_key=dmall_cs_fe&path=/";
  } else if (/test/.test(location.hostname)) {
    href =
      "http://passport.test.yunshanmeicai.com/?app_key=dmall_cs_fe&path=/";
  } else if (/stage/.test(location.hostname)) {
    href =
      "http://passport.stage.yunshanmeicai.com/?app_key=dmall_cs_fe&path=/";
  } else {
    href =
      "http://passport.yunshanmeicai.com/?app_key=dmall_cs_fe&path=/";
  }
  // 账号无用，停顿 5 秒跳转
  setTimeout(() => { window.location.href = href; }, timeout);
}

export function connectToOtherPassport(MC_ST) {
  return
  let url = '';
  let src;
  let keySrc = 'https://dmallcs.stage.yunshanmeicai.com/static/dist/views/purchaselist/purchaselist_management.html';
  
  if (/dev/.test(location.hostname)) {
    src = `https://dmallcs.stage.yunshanmeicai.com/static/views/order/order_management.html?MC_ST=${MC_ST}&path=%2F`;
  } else if (/test/.test(location.hostname)) {
    url = `http://dev.ska.test.yunshanmeicai.com:8080/?MC_ST=${MC_ST}`;
    src = `https://dmallcs.stage.yunshanmeicai.com/static/views/order/order_management.html?MC_ST=${MC_ST}&path=%2F`;
  } else if (/stage/.test(location.hostname)) {
    url = ` http://dev.ska.stage.yunshanmeicai.com:8080/?MC_ST=${MC_ST}`;
    src = `https://dmallcs.stage.yunshanmeicai.com/static/views/order/order_management.html?MC_ST=${MC_ST}&path=%2F`;
  } else {
    url = `http://dev.ska.online.yunshanmeicai.com:8080/?MC_ST=${MC_ST}`;
    src = `https://dmallcs.yunshanmeicai.com/static/views/order/order_management.html?MC_ST=${MC_ST}&path=%2F`;
    keySrc = 'https://dmallcs.yunshanmeicai.com/static/dist/views/purchaselist/purchaselist_management.html';
  }
  // 打通其它系统
  if(/debugger/.test(location.href)) console.log(url);

  var dmall = document.createElement('iframe');
  dmall.setAttribute('style', "width:0;height:0;display:none");
  dmall.src = src;
  document.body.appendChild(dmall);
  // 打通 keyclient
  var keyclient = document.createElement('iframe');
  keyclient.setAttribute('style', "width:0;height:0;display:none");
  keyclient.src = keySrc;
  document.body.appendChild(keyclient);
}
